import React from 'react';
import {Text, View} from 'react-native';
import {styles} from './styles';

interface OrderedListProps {
  items: Array<string | React.ReactNode>;
  type?: 'normal' | 'roman';
}
export const OrderedList = ({items}: OrderedListProps) => {
  return (
    <View style={styles.listContainer}>
      {items.map((item, index) => (
        <View key={index} style={styles.listItem}>
          <Text style={styles.itemNumber}>{index + 1}.</Text>
          <Text style={styles.itemText}>{item}</Text>
        </View>
      ))}
    </View>
  );
};
